module.exports = __webpack_public_path__ + "img/gongxi.9d400e8f.png";